
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import { IBreadCrumbRoute } from "@/types/index";
import HowToScheduleTripContent from "@/components/HowToScheduleTripContent.vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import store from "@/store";

export default Vue.extend({
  name: "how-to-schedule-trip",
  components: { HeroBanner, BreadCrumb, HowToScheduleTripContent },
  mixins: [UIFeatureMixin],
  data() {
    return {
      routes: [
        { to: { name: "home" }, text: "Home" },
        { to: { name: "howToScheduleTrip" }, text: "How to Schedule a Trip" },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "HTS_HERO_C,HTS_CONTEN,HTS_STEPS,HTS_FOOTER,FXD_RT_TRS,IMG_PLAN,FLT_CNTIES,HTS_CONTN2"
    );
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
